export const GET_HELP_ARTICLES = 'GET_HELP_ARTICLES'
export const GET_HELP_CATEGORIES = 'GET_HELP_CATEGORIES'